import script from "./FiltersConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltersConfiguration.vue?vue&type=script&setup=true&lang=js"

import "./FiltersConfiguration.vue?vue&type=style&index=0&id=1689894c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1689894c"]])

export default __exports__